import Angle from './Angle';

export default Angle;
